export const TmmRecords = {
  EAN: "ISBN",
  FORMAT: "Format",
  EBOOK_ISBN: "eBook ISBN",
  FULL_TITLE: "TITLE",
  TITLEPREFIXANDTITLE: "Title Prefix",
  SUBTITLE: "Subtitle",
  AMAZON_SUBTITLE: "Amazon Subtitle",
  SERIES_NAME: "Series",
  US_PRICE: "US Price",
  CANADIAN_PRICE: "Canadian Price",
  UK_PRICE: "UK Price",
  AUTHOR_1: "Author",
  TESTIMPRINTFROMHNA: "Imprint",
  BISAC1_DESC: "BISAC Description",
  SEASON: "Season",
  BISAC_STATUS: "Bisac Status",
  ORIGIN: "Origin",
  EDITOR: "Editor",
  MANAGING_EDITOR: "Managaing Editor",
  PARENT_ISBN: "Parent ISBN",
  PUB_DATE: "Pub Date",
  WAREHOUSE_DATE: "Warehouse Date",
  RELEASE_DATE: "Release Date",
  GROUP_1: "Division",
  LICENSED: "Licensed",
  LICENSOR: "Licensor",
  MTD_Gross: "MTD Gross",
  MTD_Return: "MTD Return",
  MTD_Net: "MTD Net",
  YTD_Gross: "YTD Gross",
  YTD_Return: "YTD Return",
  YTD_Net: "YTD Net",
  LTD_Gross: "LTD Gross",
  LTD_Return: "LTD Return",
  LTD_Net: "LTD Net",
  Sell_Through_Pct: "Sell Through %",
  Indy_Usable: "Indy Usable",
  BACKORDER_QTY: "Backorder Qty",
};

export const IndyBoUnitsHeaders = {
  ORG_NAME: "Organization",
  ACCOUNT_NAME: "Account",
  REASON: "Reason",
  // ORGANIZATION_ID: "Organization ID",
  // ACCOUNT_NBR: "Account ID",
  Total_BO_Units: "Total BO Units",
};

export const InventoryStockReportHeaders = {
  ISBN: "ISBN",
  TITLE: "Title",
  AUTHOR: "Author",
  SEASON: "Season",
  FORMAT: "Format",
  INDY_USABLE: "Indy Usable",
  BACKORDER_QTY: "Backorder Qty",
  US_PRICE: "US Price",
  PUB_DATE: "Pub Date",
  DIVISION: "Division",
  IMPRINT: "Imprint",
  DISTRIBUTION_CLIENT: "Distribution Client",
  CATEGORY1: "Category",
  BISAC_1: "BISAC",
  BISAC1_DESC: "BISAC Description",
 
};
